import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Input,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  ButtonToolbar,
  Whisper,
  Popover,
} from 'rsuite'
// import pathname from '../../constants/pathname'
// import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
// import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import TooltipButton from '../../components/buttons/TooltipButton'
import pathname from '../../constants/pathname'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { downloadFile } from '../../utils/fileUtil'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { getValueFromOptions, getValueOptionsByLabel } from '../../utils/dataUtil'
import {
  downloadEfillingFileByPath,
  downloadFormEfillingFileByPath,
} from '../../redux/actions/eFilling'

export default function ListFormeFillingTable({
  schema,
  data,
  loading,
  onDelete,
  onSelect,
  isViewMode,
  onSearch,
  onCancel,
  handleAddBankAccount = () => {},
  projectCode: _projectCode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [pathFile, setPathFile] = useState([])
  const [txtModelTypeVal, setTxtModelTypeVal] = useState(0)
  const [txtSubmisTypeVal, setTxtSubmisTypeVal] = useState(0)
  const [txtSubmisStatusVal, setTxtSubmisStatusVal] = useState(0)
  const [submitStartDate, setSubmitStartDate] = useState()
  const [submitEndDate, setSubmitEndDate] = useState()
  const [txtDataTypeVal, setTxtDataTypeVal] = useState(0)
  const [isError, setIsError] = useState(false)
  const [projectcode, setProjectcode] = useState('')
  const MenuPopover = ({ children, ...rest }) => (
    <Popover {...rest} full>
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Popover>
  )

  useEffect(() => {
    if(_projectCode){
      setProjectcode(_projectCode)
    }
  }, [_projectCode])

  const handleSearch = () => {
    onSearch(
      submitStartDate,
      submitEndDate,
      txtModelTypeVal,
      txtSubmisTypeVal,
      txtSubmisStatusVal,
      txtDataTypeVal,
      projectcode
    )
  }

  const handleCancel = () => {
    setTxtModelTypeVal(0)
    setTxtSubmisTypeVal(0)
    setTxtSubmisStatusVal(0)
    setTxtDataTypeVal(0)
    setSubmitStartDate('')
    setSubmitEndDate('')
    setProjectcode('')
    onCancel()
  }
  const onDownload = (rowData) => {
    // console.log('onDownload==>', rowData)
    callGetDownloadService(rowData, 'download')
  }
  const onPreview = (rowData) => {
    // console.log('onPreview==>', rowData)
    callGetDownloadService(rowData, 'preview')
  }

  const callGetDownloadService = async (rowData, type) => {
    // console.log('callGetDownloadService==>', rowData)
    startLoading()

    try {
      let file = await downloadFormEfillingFileByPath(
        rowData.id,
        getValueOptionsByLabel(schema.forms.modelType.options, rowData.modelType)
      )

      const url = window.URL.createObjectURL(
        new Blob([file], { type: file.type + ';charset=utf-8' })
      )
      const link = document.createElement('a')
      link.href = url
      if (type == 'download') {
        link.setAttribute(
          'download',
          rowData.id,
          getValueOptionsByLabel(schema.forms.modelType.options, rowData.modelType)
        )
      } else {
        link.target = '_blank'
        link.setAttribute(
          'value',
          rowData.id,
          getValueOptionsByLabel(schema.forms.modelType.options, rowData.modelType)
        )
      }

      document.body.appendChild(link)
      setIsError()
      link.click()
    } catch (e) {
      if (type == 'download') {
        setIsError('ดาวน์โหลดล้มเหลว ' + e?.response?.status + ' ' + e?.response?.statusText)
      } else {
        setIsError('แสดงล้มเหลว ' + e?.response?.status + ' ' + e?.response?.statusText)
      }
    }
    doneLoading()
  }

  const onDownloadTemplate = (path, fileName) => {
    // console.log('onDownloadTemplate==>', path)
    handleTemplateFile(path, fileName)
  }

  const handleTemplateFile = async (path, fileName) => {
    startLoading()
    try {
      var file = await downloadEfillingFileByPath(path)
      var fileType = '.xlsx'
      // console.log('file==>', file)
      downloadFile(file, 'Template เอกสาร ' + fileName + fileType)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ล้มเหลว ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Row>
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <Dropdown
            title={schema.forms.templateFile.label}
            icon={<Icon icon="cloud-download" />}
          // placement="leftStart"
          >
            {schema.forms?.templateFile?.options?.map((item) => {
              return (
                <Dropdown.Item
                  icon={<Icon icon="cloud-download" />}
                  onClick={() => onDownloadTemplate(item.value, item.label)}
                >
                  {item.label}
                </Dropdown.Item>
              )
            })}
          </Dropdown>
        </Col>
      </Row>

      <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
        <div style={{ marginTop: -10, marginBottom: -10 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.projectCode?.label || 'รหัสโครงการ'}
              <Input
                value={projectcode}
                defaultValue={_projectCode}
                onChange={(value) => {
                  setProjectcode(value)
                }}
              />
            </Col>

            <Col lg={12} md={12} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submitStartDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={submitStartDate}
                onChange={(value) => {
                  setSubmitStartDate(value)
                }}
                disabledDate={(date) =>
                  submitEndDate && moment(submitEndDate).isBefore(date, new Date())
                }
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submiyEndDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={submitEndDate}
                onChange={(value) => {
                  setSubmitEndDate(value)
                }}
                disabledDate={(date) =>
                  submitStartDate && moment(submitStartDate).isAfter(date, new Date())
                }
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.modelType.label}
              <SelectPicker
                searchable={false}
                value={txtModelTypeVal}
                data={schema.forms.modelType.options}
                block
                onChange={(value) => {
                  setTxtModelTypeVal(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submisType.label}
              <SelectPicker
                searchable={false}
                value={txtSubmisTypeVal}
                data={schema.forms.submisType.options}
                block
                onChange={(value) => {
                  setTxtSubmisTypeVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submisStatus.label}
              <SelectPicker
                searchable={false}
                value={txtSubmisStatusVal}
                data={schema.forms.submisStatus.options}
                block
                onChange={(value) => {
                  setTxtSubmisStatusVal(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.dataType.label}
              <SelectPicker
                searchable={false}
                value={txtDataTypeVal}
                data={schema.forms.dataType.options}
                block
                onChange={(value) => {
                  setTxtDataTypeVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SearchButton disabled={false} onClick={handleSearch}>
                ค้นหา
              </SearchButton>
              <CancelButton disabled={false} onClick={handleCancel}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </div>
      </Panel>

      <Row>
        {!isViewMode && (
          <IconButton
            appearance="primary"
            icon={<Icon icon="plus" />}
            onClick={() => {
              handleAddBankAccount()
            }}
            //size="sm"
            style={{ float: 'right', marginTop: 10, marginBottom: 10 }}
          >
            เพิ่มข้อมูลยื่น eFilling
          </IconButton>
        )}
      </Row>

      <Table wordWrap autoHeight loading={loading} data={data || []} style={{ marginTop: 10 }}>
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={200} align={'center'}>
          <HeaderCell>{schema.forms.submisStatus.label}</HeaderCell>
          {/* <Cell dataKey="submisStatusLabel" /> */}
          <Cell>
            {(rowData, index) => {
              // console.log('rowData==>', rowData)
              let color = '',
                _className = ''
              switch (rowData.submisStatus) {
                case '0':
                  color = '#0d6efdad '
                  _className = 'mod1rs-icon-size-lg'
                  return (
                    <>
                      <div style={{ display: 'flex', marginLeft: 10 }}>
                        <Icon icon="circle" size="lg" style={{ color: color }} />

                        <span style={{ marginLeft: 10, marginTop: 2 }}>
                          {getValueFromOptions(
                            schema.forms.submisStatus.options,
                            rowData.submisStatus
                          )}
                        </span>
                      </div>
                    </>
                  )

                  break
                case '1':
                  color = '#ff9800'
                  _className = 'mod2rs-icon-size-lg'
                  return (
                    <>
                      <div style={{ display: 'flex', marginLeft: 10 }}>
                        <Icon icon="info" size="lg" style={{ color: color }} />
                        {/* <p
                          dangerouslySetInnerHTML={{ __html: rowData.submisStatusLabel }}
                          style={{ marginLeft: 10, marginTop: 2 }}
                        /> */}
                        <span style={{ marginLeft: 10, marginTop: 2 }}>
                          {getValueFromOptions(
                            schema.forms.submisStatus.options,
                            rowData.submisStatus
                          )}
                        </span>
                      </div>
                    </>
                  )
                  break
                case '2':
                  color = '#2da888'
                  _className = 'mod3rs-icon-size-lg'
                  return (
                    <>
                      <div style={{ display: 'flex', marginLeft: 10 }}>
                        <Icon icon="circle" size="lg" style={{ color: color }} />
                        {/* <p
                          dangerouslySetInnerHTML={{ __html: rowData.submisStatusLabel }}
                          style={{ marginLeft: 10, marginTop: 2 }}
                        /> */}
                        <span style={{ marginLeft: 10, marginTop: 2 }}>
                          {getValueFromOptions(
                            schema.forms.submisStatus.options,
                            rowData.submisStatus
                          )}
                        </span>
                      </div>
                    </>
                  )
                  break
                case '9':
                  color = '#798388'
                  _className = 'mod3rs-icon-size-lg'
                  return (
                    <>
                      <div style={{ display: 'flex', marginLeft: 10 }}>
                        <Icon icon="circle" size="lg" style={{ color: color }} />
                        {/* <p
                            dangerouslySetInnerHTML={{ __html: rowData.submisStatusLabel }}
                            style={{ marginLeft: 10, marginTop: 2 }}
                          /> */}
                        <span style={{ marginLeft: 10, marginTop: 2 }}>
                          {getValueFromOptions(
                            schema.forms.submisStatus.options,
                            rowData.submisStatus
                          )}
                        </span>
                      </div>
                    </>
                  )
                  break
                default:
                  return ''
                  break
              }
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>{schema.forms.projectCode.label}</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={150}>
          <HeaderCell>{schema.forms.contractNo.label}</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>

        <Column width={200}>
          <HeaderCell>วัน/เดือน/ปี ที่ยื่นแบบ</HeaderCell>
          <Cell dataKey="submisDate" />
        </Column>

        <Column width={120}>
          <HeaderCell>{schema.forms.modelType.label}</HeaderCell>
          <Cell dataKey="modelType" />
        </Column>

        <Column width={150}>
          <HeaderCell>เดือน/ปี(ภาษี)</HeaderCell>
          <Cell dataKey="taxMonth" />
        </Column>

        <Column width={130} align={'center'}>
          <HeaderCell>{schema.forms.submisList.label}</HeaderCell>
          <Cell dataKey="submisList" />
        </Column>

        <Column width={200} align={'center'}>
          <HeaderCell>{schema.forms.taxReferCode.label}</HeaderCell>
          <Cell dataKey="taxReferCode" />
        </Column>

        <Column width={150} align={'center'}>
          <HeaderCell>{schema.forms.submisType.label}</HeaderCell>
          {/* <Cell dataKey="submisTypeLabel" /> */}
          <Cell>
            {(rowData) => {
              // console.log(rowData.submisType)
              // console.log(schema)
              return getValueFromOptions(schema.forms.submisType.options, rowData.submisType)
            }}
          </Cell>
        </Column>

        <Column width={150} align={'center'}>
          <HeaderCell> {schema.forms.dataType.label}</HeaderCell>
          {/* <Cell dataKey="dataTypeLabel" /> */}
          <Cell>
            {(rowData) => {
              // console.log(rowData.dataType)
              // console.log(schema)
              return getValueFromOptions(schema.forms.dataType.options, rowData.dataType)
            }}
          </Cell>
        </Column>

        <Column width={80} align={'center'}>
          <HeaderCell>
            <span></span>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <TooltipButton
                      isStart={true}
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={(e) => onPreview(rowData)}
                    />
                    <TooltipButton
                      isStart={false}
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={(e) => onDownload(rowData)}
                    />
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>

        {!isViewMode && (
          <Column width={190} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={() => onSelect(rowData)}
                        disabled={!rowData.isEditabled}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={() => (setDeleteObj(rowData), setIsShowConfirm(true))}
                        disabled={!rowData.isDeleteabled}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onDelete(deleteObj)
          setIsShowConfirm(false)
        }}
      />
    </>
  )
}
